import React from "react";
import { HOME_URL } from "../../const/URL.const";
import { useHistory } from "react-router-dom";
// import { useAuth0 } from "../../yoello-lib/modules/auth/Auth0";
import {ReactComponent as LogoutIcon} from "../../assets/images/icon-logout.svg";
import IconButton from "@material-ui/core/IconButton";
import { useSelector } from "react-redux";
import { IReduxAppState } from "../../reducers";
import { makeStyles } from "@material-ui/styles";
import { Button } from "@material-ui/core";
import { useAuthenticationContext } from "../../yoello-lib/modules/auth/AuthenticationContext";
import { useUserLogout } from "../../hooks/useUserLogout";

const useStyles = makeStyles({
  root: {
    height: "3rem",
    backgroundColor: "#E8EAF4",
    padding: "0.5rem 0.75rem",
    borderRadius: "0.5rem",
    "&:hover": {  
      backgroundColor: "#CFD1DD"
    }
  },
  name: {
    fontSize: "0.875rem",
    color: "#737FA4",
    paddingRight: "0.5rem"
  },
  icon: {
    height: "1rem"
  }
})

/**Login and out button will display depending if authenticated */
const LogInOutButton = () => {
  const classes = useStyles();
  // const { isAuthenticated, logout } = useAuth0()!;
  const { isAuthenticated } = useAuthenticationContext();
  const { logout } = useUserLogout();
  const history = useHistory();

  const merchant = useSelector(
    (state: IReduxAppState) => state.merchant
  );

  return isAuthenticated ? (
    <Button 
      
      className={classes.root} 
      onClick={logout}
    >
        { merchant && merchant?.first_name&&
          <div className={classes.name}>
            {`${merchant.first_name}`}
          </div>
        }
        <LogoutIcon className={classes.icon} />
    </Button>
    
  ) : (
    <IconButton
      className="login"
      aria-label="login"
      onClick={() => history.push(HOME_URL)}
    >
      <LogoutIcon />
    </IconButton>
  );
};

export default LogInOutButton;
